// plan-03 S02: cadence constants — bible §15 + PART X

export const STREAM_CPS = 88
export const LOG_CPS = 88
export const CURSOR_BPM = 48
export const IDLE_MEAN_S = 12
export const IDLE_MIN_S = 4
export const IDLE_MAX_S = 22
